import { render, staticRenderFns } from "./RecentAlerts.vue?vue&type=template&id=850f1d60&scoped=true"
import script from "./RecentAlerts.vue?vue&type=script&lang=js"
export * from "./RecentAlerts.vue?vue&type=script&lang=js"
import style0 from "./RecentAlerts.vue?vue&type=style&index=0&id=850f1d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850f1d60",
  null
  
)

export default component.exports